<script lang="ts" setup>
    import { useUserStore } from '@/stores/user';
    import { computed, onMounted } from 'vue';
    import { useDisplay, useTheme } from 'vuetify';
    import { IBalance } from '@/types';
    import { useNumberFormatter } from '@/composables/useNumberFormatter';

    const userStore = useUserStore();
    const theme = useTheme();
    const display = useDisplay();
    const { t } = useI18n();
    const { formatNumber } = useNumberFormatter();

    const userBalanceInfo = computed<IBalance>(() => userStore.balance);

    onMounted((): void => {
        console.log('Component AppMenuAccountBalanceInfo mounted.');
    });
</script>
<template>
    <v-card-text v-if="userStore.login && userBalanceInfo !== undefined && Object.keys(userBalanceInfo).length" class="py-2">
        <v-container class="font14 pl-3 pr-0 py-2">
            <v-row>
                <v-col class="px-2 pt-0 pb-0 user-balance" cols="4">
                    {{ t('menu.credit') }}
                    <br />

                    <span :class="[display.xs.value ? 'lh-1-1' : '', theme.name.value === 'dark' ? 'text-white' : 'text-black', 'bold']">
                        {{ userStore.currency.symbol }}{{ formatNumber(userBalanceInfo.credit, 'money') }}
                    </span>
                </v-col>
                <v-col class="px-2 pt-0 pb-0 user-balance" cols="4">
                    {{ t('menu.balance') }}
                    <br />
                    <span :class="[userBalanceInfo.balance < 0 ? 'redText' : 'greenText', 'bold']">{{ userStore.currency.symbol }}{{ formatNumber(userBalanceInfo.balance, 'money') }}</span>
                </v-col>
                <v-col class="px-2 pt-0 pb-0 user-balance" cols="4">
                    {{ t('menu.exposure') }}
                    <br />
                    <span class="orangeText bold">{{ userStore.currency.symbol }}{{ formatNumber(userBalanceInfo.exposure, 'money') }}</span>
                </v-col>
            </v-row>
        </v-container>
    </v-card-text>
</template>
<style scoped>
    .v-theme--light .user-balance {
        color: grey;
    }

    .v-theme--dark .user-balance {
        color: #a7aab4;
    }
</style>
